import axios from 'axios';

export const API = {
  REVERSE_PROXY_API: 'http://localhost:3002/api',
  PRODUCTION_API: 'https://api.salesclue.io',
  DEVELOPMENT_API: 'https://api-dev.salesclue.io',
} as const;

export const SCLU_HOST = {
  MAIN: 'sclu.io',
  DEV: 'dev.sclu.io',
} as const;

const reverseProxy = (host: string) => `${getHttpOrHttps(host)}${host}/api`;

export const getBaseUrl = (host: string) => {
  if (process.env.NODE_ENV === 'production' && host === SCLU_HOST.MAIN) {
    return API.PRODUCTION_API;
  }

  if (process.env.NODE_ENV === 'production' && host === SCLU_HOST.DEV) {
    return API.DEVELOPMENT_API;
  }

  return reverseProxy(host);
};

const getHttpOrHttps = (host: string) => {
  return host?.includes('localhost') ? 'http://' : 'https://';
};

export const api = axios.create({
  baseURL: getBaseUrl(globalThis?.window?.location.host),
  withCredentials: true,
});
